// extracted by mini-css-extract-plugin
export default {"main_containter":"loader_main_containter__uNGgz","loader":"loader_loader__Zo1p2","rotation":"loader_rotation__Zr-Kh"};